const debug = process.env.REACT_APP_DEBUG && false;
export const handleLinkSelectedObjects = ({ matchedPrimary, selectedObjects, transactionFunctions, createEdgeAdjacentFilter, edgeAttributes, setShowSearch, }) => {
    debug && console.log('handleLinkSelectedObjects', { matchedPrimary, selectedLinkObjects: selectedObjects, createEdgeAdjacentFilter });
    if (matchedPrimary) {
        transactionFunctions.linkObjectsToPrimary(matchedPrimary, selectedObjects, createEdgeAdjacentFilter, edgeAttributes);
    }
    else {
        console.log('WARN: handleLinkSelectedObjects fell through if elses ');
    }
    setShowSearch(false);
};
